import React, { useMemo } from "react";
import CommonUserAvatar from "../../CommonUserAvatar";

const TeamProfileCard = ({ team, size = "medium", disabled = false }) => {
  const name = useMemo(() => {
    return team?.friendlyName;
  }, [team]);
  return (
    <div className={`d-flex flex-row align-items-center gap-3 pe-3 ${disabled ? "hs-cursor-not-allowed" : "cursor-pointer"}`}>
      <div>
        <CommonUserAvatar name={name} icon={team?.avatar} size={size === "small" ? 23 : 40} />
      </div>
      <div>{name ? <div className="hs-fs-14 fs-fw-500 hs-fw-500">{name}</div> : null}</div>
    </div>
  );
};

export default TeamProfileCard;